// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W31y","select":"styles_select__35bLt"};